@if (combinedData$ | async; as combinedData) {
  @let completeState = completeReportButtonState$ | async;
  @let completeLabelKey = getCompleteButtonLabelKeyForState(completeState);
  @let completeTooltipKey = getCompleteButtonTooltipKeyForState(completeState);
  <gc-modal
    class="tab-content-container"
    [class.has-completed-meta]="
      !!combinedData.installationReport.data?.isCompleted
    "
    [class.has-complete-tooltip-overlay]="
      !isCombinedDataLoading(combinedData) &&
      isDeliveryPortalFi &&
      arcEnabled &&
      !!completeLabelKey &&
      !!completeTooltipKey
    "
    [headerTitle]="'installationReportV2.modal.header' | translate"
    [showCloseIcon]="true"
    [width]="'fullscreen'"
    [closeOnOutsideClick]="false"
    [primaryButtonText]="
      isCombinedDataLoading(combinedData)
        ? undefined
        : ('installationReportV2.modal.saveBtn' | translate)
    "
    [primaryButtonIsLoading]="
      installationReportUpdateMutation.getStateOnce().isLoading
    "
    [primaryButtonIsDisabled]="
      !!combinedData.installationReport.data?.isCompleted
    "
    [secondaryButtonText]="
      !isCombinedDataLoading(combinedData) &&
      isDeliveryPortalFi &&
      arcEnabled &&
      completeLabelKey
        ? (completeLabelKey | translate)
        : undefined
    "
    [secondaryButtonIsLoading]="
      installationReportCompleteMutation.getStateOnce().isLoading
    "
    [secondaryButtonIsDisabled]="
      !isCompleteReportPrimaryButtonEnabled(completeState)
    "
    (closeModal)="closeModal()"
    (primaryButtonClicked)="onProceed()"
    (secondaryButtonClicked)="onCompleteReportButtonClick(completeState)"
  >
    @if (combinedData.installationReport.data; as installationReport) {
      @if (installationReport.isCompleted) {
        <app-installation-report-completed-by-header
          [report]="installationReport"
        />
      }
    }
    @if (
      (combinedData.installationReport.hasErrors ||
        combinedData.deliveryItem.hasErrors) &&
      !combinedData.deliveryItem.isLoading &&
      !combinedData.installationReport.isLoading
    ) {
      <app-error-information
        [errorString]="'installationReport.errorText'"
        [iconName]="'smileySad'"
        [iconColor]="'critical'"
      />
    }
    @if (
      combinedData.installationReport.isLoading ||
      combinedData.deliveryItem.isLoading
    ) {
      <ipo-loading-spinner></ipo-loading-spinner>
    }
    @if (combinedData.installationReport.data; as installationReport) {
      @if (combinedData.deliveryItem.data; as deliveryItem) {
        <app-installation-report-content-v2
          [form]="form"
          [installationReport]="installationReport"
          [deliveryItem]="deliveryItem"
          [saveLoadingState]="
            installationReportUpdateMutation.getStateOnce().isLoading
          "
          (handleSaveReport)="onProceed()"
        />
        @if (
          !isCombinedDataLoading(combinedData) && completeLabelKey;
          as labelKey
        ) {
          @if (completeTooltipKey; as tooltipKey) {
            <div class="installation-report-complete-tooltip-overlay">
              <gc-tooltip [text]="tooltipKey | translate" [position]="'top'">
                <gc-button
                  [variant]="'secondary'"
                  [size]="'full'"
                  [disabled]="true"
                >
                  {{ labelKey | translate }}
                </gc-button>
              </gc-tooltip>
            </div>
          }
        }
      }
    }
    <app-feedback-alert />
    <app-detailed-error-feedback-alert />
  </gc-modal>
  @if (confirmationState !== 'closed') {
    <app-complete-report-confirmation-modal
      [state]="confirmationState"
      [isLoading]="installationReportCompleteMutation.getStateOnce().isLoading"
      (confirmed)="onConfirmComplete()"
      (dismissed)="onDismissConfirmation()"
    />
  }
}
